<template>
  <button class="search-filter-filter-button" :style="filterButtonElStyles">
    {{ label }}
    <span
      v-if="isActive"
      class="search-filter-filter-count"
      :style="activeCountElStyles"
    >
      {{ activeCount }}
    </span>
    <IconPlus v-else width="10" height="10" />
  </button>
</template>

<script>
import IconPlus from "../../Icons/IconPlus.vue";
import { colord } from "colord";

export default {
  name: "FilterButton",
  components: { IconPlus },
  inject: ["currentRefinements"],
  props: {
    label: {
      type: String,
      required: true,
    },
    filterKey: {
      type: String,
      required: true,
    },
    accentColor: {
      type: String,
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.currentRefinements.some(
        (item) => item.key === this.filterKey,
      );
    },
    activeCount() {
      if (this.isActive) {
        const currentRefinement = this.currentRefinements.find(
          (item) => item.key === this.filterKey,
        );

        return currentRefinement.value.length;
      }
    },
    filterButtonElStyles() {
      return {
        color: this.isActive ? "var(--search-filter-accent-color)" : "inherit",
      };
    },
    activeCountElStyles() {
      return {
        // Determine color of count based on accent color
        color: colord(this.accentColor).isDark() ? "#FAFAFA" : "#1D1D1F",
      };
    },
  },
};
</script>
